import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import CustomCard from "./CustomCard";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import useDataManager from "hooks/useDataManager";
import { IconButton, Stack, Typography } from "@mui/material";
import { getFaultBgcolor } from "config/functions";
import moment from "moment";
import { DATE_TIME_MINI_FORMAT, PLUGIN_NAME } from "config/const";
import useCheckData from "hooks/CheckData";

const MAX_VISIBLE = 3;

const ShowNotification = () => {
  const { hasPlugin } = useCheckData();
  const { notificationReadBy } = useDataManager()
  const { bt } = useBizTypeTranslation();
  const [visibleNotifications, setVisibleNotifications] = useState([])

  const list = useSelector((state) => state.notification?.list || []);
  const user = useSelector((state) => state.userSettings?.user);
  const showMassage = useSelector((state) => state?.sys.showMassage);
  const selectedPlugin = useSelector((state) => state?.userSettings?.selectedPlugin);

  useEffect(() => {
    if (list.length > 0) {
      let newList = list.filter((item) => !item?.readBy?.some((i) => i?.employee?._id === user?.id))

      if (!hasPlugin(PLUGIN_NAME.MICRO_CONTROLLERS)) {
        newList = newList?.filter(i => !i?.mc)
      }

      setVisibleNotifications(
        newList
          .sort((a, b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0))
          .slice(0, MAX_VISIBLE)
      )
    }

  }, [list, user, selectedPlugin]);

  const handleClose = (item) => {
    notificationReadBy(item, user, list)
  };

  if (!visibleNotifications.length) return null;

  return (
    <Stack
      spacing={1.5}
      sx={{
        position: "fixed",
        bottom: showMassage ? 100 : 15,
        right: 16,
        width: 300,
      }}
    >
      {visibleNotifications.map((item, idx) => {
        return (
          <CustomCard
            key={item?._id}
            bgcolor={getFaultBgcolor(item.title)}
            padding={2}
            pb={2}
            sx={{
              boxShadow: 4,
              borderRadius: 2,
              animation: `pulse ${idx + 10}s infinite`,
              "@keyframes pulse": {
                "0%": { opacity: 1 },
                "5%": { opacity: 0.6 },
                "20%": { opacity: 1 },
                "100%": { opacity: 1 },
              },
            }}
          >
            <Stack spacing={1}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"

              >
                <Stack spacing={0.5}>
                  <Typography variant="subtitle2" fontWeight={700}>
                    {item?.mc?.name}
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    {bt(item.title)}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.created ? moment(item.created).format(DATE_TIME_MINI_FORMAT) : ""}
                  </Typography>
                </Stack>

                <IconButton
                  size="small"
                  onClick={() => handleClose(item)}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Stack>
            </Stack>
          </CustomCard>
        )
      })}

    </Stack>
  );
};

export default ShowNotification;